import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService, CookieService, EventsService, SeoService, StorageService, UtilService, VariablesService } from 'src/app/shared/services';
import { HfHeaderComponent } from '../hf-header/hf-header.component';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { HfFooterComponent } from '../hf-footer/hf-footer.component';
import { HfGuard } from 'src/app/shared/guards/health-first/health-first.guard';

@Component({
  selector: 'app-health-first-layout',
  standalone: true,
  imports: [
    CommonModule,
    HfHeaderComponent,
    RouterModule,
    RouterOutlet,
    HfFooterComponent
  ],
  templateUrl: './health-first-layout.component.html',
  styleUrls: ['./health-first-layout.component.scss']
})
export class HealthFirstLayoutComponent {
  constructor(
    private events: EventsService,
    public util: UtilService,
    public vars: VariablesService,
    private auth: AuthService,
    private storage: StorageService,
    private seoService: SeoService,
    private router: Router,
    private cookieService: CookieService,
    private healthGuard: HfGuard
  ) {}

  userData;
  tags;
  hideFooter = false;

  ngOnInit() {
    this.loadWebFont();
    if (this.vars.pageName === 'healthfirst_homepage') {
      this.pageViewEvent();
    }
    this.checkUser();
    this.addMetaTags();
    this.hideFooterOnApp();
  }

  hideFooterOnApp() {
    const platform = this.cookieService.getCookie('platform');
    if (/ios|android/.test(platform?.toLowerCase())) {
      this.hideFooter = true;
    }
  }

  addMetaTags() {
    const tagsObj = {
      description: "Ketto HealthFirst powered by MediBuddy A powerful duo for enhanced healthcare. Get top-notch medical services for you & your family at ease.",
      keywords: 'ketto, ketto.org, Insurance, medibuddy, health and wellness, health and wellness portal, Health Insurance, Health Insurance Plans, Health Insurance Plans for family, Health Insurance Policy, Life insurance',
      title: "Ketto's HealthFirst Powered by MediBuddy | Family Health Plan",
      image: 'https://d1vdjc70h9nzd9.cloudfront.net/media/directupload/4000/4303/image/J1Mszs6GYlTpufOHOKN1xcZRxQhzoXCTy16FgKNV.jpg',
      url: 'https://www.ketto.org/healthfirst',
      site: 'Ketto.org'
    };
    this.tags = this.seoService.createTagObject(tagsObj);
    this.seoService.addMetaTags(this.tags)
    this.util.setPageTitle('Ketto\'s HealthFirst Powered by MediBuddy | Family Health Plan');
  }

  checkUser() {
    const user = this.storage.get('userdata');
    // in thnakyou page and in calculator we are calling inside page component 
    if (user && this.router.url.match('healthfirst/calculator|healthfirst/thankyou') || user && this.router.url === '/healthfirst') {
      this.getUserProfile();
    }
  }

  getUserProfile() {
    this.auth.getUserProfile().subscribe((val: any) => {
      if (val.data) {
        this.userData = val.data;
        this.vars.userData.next(val.data);
        this.util.setUserData(val.data);
        if (typeof window !== 'undefined') {
          localStorage.setItem('userdata', JSON.stringify(val.data));
        }
        this.healthGuard.checkHfRedirection(this.userData, this.router);
      }
    })
  }
  
  loadWebFont() {
    this.util.addCssToGlobal('https://fonts.googleapis.com/css2?family=Source+Serif+4:ital,opsz,wght@1,8..60,700&display=swap')
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      referrer_page: this.util.getReferrer()
    };
    this.events.onLoadSystemEvent(pageViewPayload);
    this.events.claverTapPush('HealthFirst Page View', {
      'Event Name': 'PageView',
    })
  }

  ngOnDestroy() {
    if (this.tags) {
      this.seoService.removeMetaTags(this.tags);
    }

  }
}
